const getLanguagesOptions = (languages = [], valueAsCode = false) => {
  return languages.map((item) => {
    return {
      label: item.name,
      value: valueAsCode ? item.code : item.id,
    };
  });
};

export default getLanguagesOptions;
